import { jwtDecode } from "jwt-decode"

export interface ValidationError {
  field: string
  message: string
}

interface JwtPayload {
  exp: number
}

export const isTokenValid = (token: string): boolean => {
  try {
    const decoded = jwtDecode<JwtPayload>(token)

    if (!decoded.exp) {
      return false
    }

    const currentTime = Date.now() / 1000

    return decoded.exp > currentTime
  } catch {
    return false
  }
}

export function resolveImage(url?: string) {
  if (!url) {
    return ""
  }

  try {
    const parsed = new URL(url)

    if (parsed.pathname === "/" || parsed.pathname === "") {
      return ""
    }

    return url
  } catch {
    return ""
  }
}

export const formatDateToString = (date: string) => {
  return date.toLocaleDateTime()
}

export const converteDateToSql = (date: Date): string => {
  return date.toSqlDateTime()
}

export const toInputDate = (date: Date): string => {
  return date.toInputDate()
}

export const fromInputDate = (value: string): Date => {
  const [year, month, day] = value.split("-").map(Number)

  if (!year || !month || !day) {
    return new Date(value)
  }

  return new Date(year, month - 1, day, 12, 0, 0)
}

export const parseDateWithoutTimezoneShift = (value?: Date | string): Date => {
  if (!value) {
    return new Date()
  }

  if (value instanceof Date) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate())
  }

  const [datePart] = value.split("T")

  const [year, month, day] = datePart.split("-").map(Number)

  if (!year || !month || !day) {
    const fallback = new Date(value)

    return new Date(fallback.getFullYear(), fallback.getMonth(), fallback.getDate())
  }

  return new Date(year, month - 1, day)
}

export function clone<T>(instance: T): T {
  if (!instance) {
    return instance
  }

  const copy = Object.create(Object.getPrototypeOf(instance))

  Object.assign(copy, instance)

  return copy
}

export const setDelay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export const convertToLocalMoney = (money: number) => {
  return (money ?? 0).toMoney()
}

export const currentDay = (): string => {
  return new Date().toInputDate()
}

export const currentMonthStart = (): string => {
  return new Date().toMonthStart().toInputDate()
}

export const extractYoutubeId = (url: string) => {
  const cleanUrl = url.trim()

  const match = cleanUrl.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/)

  return match?.[1] ?? ""
}

export const normalizeHexColor = (value?: string | null, fallback = "#FFFFFF") => {
  const normalized = (value ?? "").trim()

  if (!/^#?[0-9a-fA-F]{6}$/.test(normalized)) {
    return fallback.toUpperCase()
  }

  return `${normalized.startsWith("#") ? "" : "#"}${normalized}`.toUpperCase()
}
